
import { Component, Vue } from 'vue-property-decorator'
import { Getter } from "vuex-class";
import { handleFill } from '@/utils/util'
import Price from '@/components/Price/index.vue'
import { getOrderListNew } from '@/api/industryMall'
import dayjs from 'dayjs'

@Component({
  components: {
    Price
  }
})
class WeiDian extends Vue {
  @Getter companyId!: string
  handleFill = handleFill  // 作为tabs标签使用（0待支付，1待取货，3已完成，-1已取消）
  statusOptions = [
    { name: '全部', value: '', color: '#86909C', isTab: true }, // value对应的是订单状态
    { name: '待支付', value: '0', color: '#FD8305', isTab: true },
    { name: '待收货/取货', value: '1', color: '#FD8305', isTab: true },
    { name: '已完成', value: '3', color: '#10B135', isTab: true },
    { name: '已取消', value: '-1', color: '#86909C', isTab: true }
  ]
  refreshing = false
  loading = false
  finished = false
  curTab: any = ''
  params: any = {
    queryContent: '',
    pageIndex: 1,
    pageSize: 10
  }
  totalRecords = 0
  list: any[] = []

  get tabs () {
    return this.statusOptions.filter((item: any) => item.isTab)
  }

  get sftpUrl () {
    return this.$store.state.user.sftpUrl
  }

  mounted () {
    const { curTab = '' } = this.$route.query
    this.curTab = curTab
    this.getList()
  }

  onSearch () {
    this.params.pageIndex = 1
    this.getList()
  }

  changeTabs () {
    document.querySelector('.order-scroll').scrollTop = 0
    this.params.pageIndex = 1
    this.getList()
  }

  /**
   * 下拉刷新
   * */
  onRefresh () {
    this.params.pageIndex = 1
    this.refreshing = true
    this.getList()
  }

  /**
   * 上拉加载更多
   */
  onLoad () {
    this.params.pageIndex++;
    this.getList();
  }

  getStatusOptionsIdx (orderStatus: any) {
    orderStatus = Number(orderStatus)
    return this.statusOptions.findIndex((status: any) => status.value && status.value == orderStatus)
  }

  formatCreateTime (createTime: string) {
    return dayjs(createTime).format("YYYY-MM-DD HH:mm")
  }

  getList () {
    getOrderListNew({
      storeId: this.companyId,
      ...this.params,
      orderStatus: this.curTab
    })
      .then((res) => {
        if (this.refreshing || this.params.pageIndex === 1) {
          this.list = [];
        }
        const records = res.data.records.map((item: any) => {
          return {
            ...item,
            statusOptionsIdx: this.getStatusOptionsIdx(item.orderStatus),
            createTime: this.formatCreateTime(item.createTime)
          }
        })
        this.list = this.list.concat(records);
        this.totalRecords = res.data.totalRecords
        if (this.params.pageIndex >= res.data.totalPages) {
          this.finished = true;
        } else {
          this.finished = false;
        }
        this.refreshing = false;
      })
      .catch(() => {
        this.finished = true;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  toDetail (item: any) {
    this.$router.push({
      path: '/weidianOrderDetail',
      query: {
        orderId: item.orderId,
        curTab: this.curTab
      }
    })
  }
}
export default WeiDian
